import React, { useState } from 'react';

const heroImage = 'https://www.wideopenspaces.com/wp-content/uploads/sites/3/2023/11/GettyImages-1261664198.jpg?resize=1024%2C683';

const features = [
    {
        icon: '🦌',
        title: 'Deer Hunts',
        description: 'Join thrilling deer hunts and share your most impressive trophies.',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkxkoxWwl62Jn_SYgw7kjfeI5V1_63Fx7GHBHRjAeOjag6CyXH5W7_Nym-FdP1zOL_mjo&usqp=CAU',
    },
    {
        icon: '🏹',
        title: 'Track the Wild',
        description: 'Follow tracks, scout the wilderness, and connect with expert deer hunters.',
        image: 'https://www.sweeneyfeeders.com/wp-content/uploads/2014/12/d.jpg',
    },
    {
        icon: '📸',
        title: 'Share Your Trophy',
        description: 'Upload your best deer hunting moments and inspire the community.',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT2mrQ8T99X1Q1cnJLd9Sg-5harVoJhOhRdNsDIfRyArA5d4hndX_oIx4Y-Db9XbMXHh64&usqp=CAU',
    },
    {
        icon: '🎒',
        title: 'Gear Marketplace',
        description: 'Buy, sell, and review the best deer hunting equipment.',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTrfkHgmGs-oUgP78cLJma9uvKwUL7wDz6VP0Vo5VlMElPCD8oDrNpt3fEJCjvskZJyN4&usqp=CAU',
    },
];

const galleryImages = [
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6AC7pztONy1QGFe9pz6HxE7-O6dcTwJu3SqSd_k9DK4g784F1okGVsMT33okTUiH8tZ0&usqp=CAU',
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTrfkHgmGs-oUgP78cLJma9uvKwUL7wDz6VP0Vo5VlMElPCD8oDrNpt3fEJCjvskZJyN4&usqp=CAU',
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTu_ogEXlB70E9eHHYxNawPtWYjiIi7pkgzPg&s',
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDIJe7oiZnW6KjjZhKDnOB-vdlIbHN42lTzR4ZhNlDnVAoZdB3k83Gd0gEjeMS3Ks6sgg&usqp=CAU',
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZu1PN2LQdoGgEenOXP2xSnI9zItmHGV1fMQ&s',
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkkjV-PkvHzxykzlw9IGEWPpVdEZM0ukPwS_LZaQiTA4j9qtuiayxR8uYAXuZwGs1gMGw&usqp=CAU',
];

const TrophyTask: React.FC = () => {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setSubmitted(true);
        setEmail('');
    };

    return (
        <div className="min-h-screen bg-white flex flex-col font-sans">
            {/* HERO SECTION - visually and structurally separate */}
            <section className="relative h-[70vh] w-full overflow-hidden">
                <div className="absolute inset-0 w-full h-full z-0">
                    <img
                        src={heroImage}
                        alt="Deer Hero"
                        className="w-full h-[70vh] object-cover object-center"
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-transparent"></div>
                </div>
                <div className="absolute inset-0 flex flex-col items-center justify-center z-10">
                    <img
                        src="https://diasporawise.com/trophy-talk-logo.png"
                        alt="Trophy Talk Logo"
                        className="w-32 h-32 mb-4 object-contain rounded-full shadow-lg bg-white/80"
                    />
                    <h1 className="text-5xl md:text-6xl font-extrabold text-white mb-2 uppercase tracking-widest drop-shadow-lg" style={{ textShadow: '0 4px 24px #000, 0 1px 2px #000' }}>Trophy Talk</h1>
                    <p className="text-xl md:text-2xl text-white font-light mb-4 drop-shadow-lg" style={{ textShadow: '0 2px 8px #000' }}>The Ultimate Deer Hunting Community Platform</p>
                    <span className="text-white text-lg font-semibold bg-black/70 px-6 py-2 rounded shadow-lg mt-2">Launching July 15th, 2025</span>
                </div>
            </section>

            {/* REST OF THE PAGE - starts below hero */}
            <main className="flex-1 flex flex-col">
                {/* 2. Welcome/About Section */}
                <section className="max-w-4xl mx-auto px-4 py-16 flex flex-col md:flex-row items-center gap-10">
                    <div className="flex-1 text-center md:text-left">
                        <h2 className="text-3xl md:text-4xl font-bold text-black mb-4 tracking-wide uppercase">Welcome to the Wild</h2>
                        <p className="text-lg text-black mb-6 font-light">
                            Experience the thrill of the hunt, the camaraderie of the camp, and the pride of the trophy. Trophy Talk is built for real deer hunters, by real deer hunters.
                        </p>
                        <p className="text-base text-black mb-4 font-light">
                            Track majestic deer, share your stories, learn from the best, and gear up for your next adventure.
                        </p>
                    </div>
                    <div className="flex-1 flex justify-center">
                        <img
                            src="https://www.exploreminnesota.com/sites/default/files/2024-09/Deer-Hunting-Visit-Marshall.jpeg"
                            alt="Big Antler Deer"
                            className="rounded-xl shadow-lg w-full max-w-xs object-cover"
                        />
                    </div>
                </section>

                {/* 3. Features Section */}
                <section className="py-16 px-4 bg-white">
                    <h3 className="text-2xl md:text-3xl font-bold text-black text-center mb-10 uppercase tracking-wide">Deer Hunting Adventures</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                        {features.map((feature, idx) => (
                            <div key={idx} className="flex flex-col md:flex-row items-center gap-6 border border-black rounded-xl p-6 bg-white shadow-sm hover:shadow-lg transition-shadow">
                                <img src={feature.image} alt={feature.title} className="w-28 h-28 object-cover rounded-lg mb-4 md:mb-0" />
                                <div className="flex-1 text-center md:text-left">
                                    <div className="text-3xl mb-2">{feature.icon}</div>
                                    <h4 className="text-xl font-semibold text-black mb-1 uppercase tracking-wide">{feature.title}</h4>
                                    <p className="text-black text-base font-light">{feature.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* 4. Trophy Wall Section */}
                <section className="py-16 px-4 bg-gray-100">
                    <h3 className="text-2xl md:text-3xl font-bold text-black text-center mb-10 uppercase tracking-wide">Trophy Wall</h3>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-4xl mx-auto">
                        {galleryImages.map((img, idx) => (
                            <img
                                key={idx}
                                src={img}
                                alt={`Deer Hunting Gallery ${idx + 1}`}
                                className="rounded-lg object-cover w-full h-48 shadow-md hover:scale-105 transition-transform"
                            />
                        ))}
                    </div>
                    <p className="text-center text-black mt-8 font-light">Share your best deer hunting moments and see what the community is tracking this season.</p>
                </section>

                {/* 5. Community/Join Us Section */}
                <section className="py-16 px-4 bg-white flex flex-col md:flex-row items-center max-w-4xl mx-auto gap-10">
                    <div className="flex-1 text-center md:text-left">
                        <h3 className="text-2xl md:text-3xl font-bold text-black mb-4 uppercase tracking-wide">Join the Hunt</h3>
                        <p className="text-base text-black mb-6 font-light">
                            Be the first to know when we launch. Enter your email below to join the hunt!
                        </p>
                        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-center gap-2 w-full max-w-md mx-auto md:mx-0">
                            <input
                                type="email"
                                required
                                placeholder="Enter your email"
                                className="px-4 py-2 rounded border border-black focus:outline-none focus:ring-2 focus:ring-black w-full sm:w-auto bg-white text-black placeholder-black"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                disabled={submitted}
                            />
                            <button
                                type="submit"
                                className="bg-black text-white font-bold px-6 py-2 rounded transition-colors duration-200 disabled:opacity-60 border border-black"
                                disabled={submitted}
                            >
                                {submitted ? 'Thank You!' : 'Notify Me'}
                            </button>
                        </form>
                        {submitted && (
                            <p className="text-black mt-2">You’ll be the first to know when we launch!</p>
                        )}
                    </div>
                    <div className="flex-1 flex justify-center">
                        <img
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCpUoL3HjIscvmkhYwjFdfglK7i4gnt-onMw&s"
                            alt="Deer Closeup"
                            className="rounded-xl shadow-lg w-full max-w-xs object-cover"
                        />
                    </div>
                </section>

                {/* 6. Mission/Closing Section */}
                <section className="relative h-64 flex items-center justify-center text-center overflow-hidden bg-black">
                    <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTiq15ZdujVoDTVQi_BvEhE2b5bpmVLB70C1Q&s"
                        alt="Deer Silhouette"
                        className="absolute inset-0 w-full h-full object-cover object-center opacity-40"
                    />
                    <div className="relative z-10 w-full">
                        <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 uppercase tracking-wide drop-shadow">Our Mission</h3>
                        <p className="text-white text-lg font-light max-w-2xl mx-auto drop-shadow">
                            To unite the deer hunting community, inspire adventure, and celebrate every trophy. Stay tuned — the hunt begins soon!
                        </p>
                    </div>
                </section>
            </main>

            {/* Footer */}
            <footer className="text-center py-8 text-black text-xs border-t border-black bg-white">
                <div className="mb-2 tracking-widest">&copy; {new Date().getFullYear()} TROPHY TALK</div>
                <div className="opacity-70">Created with <span className="text-black">&#10084;</span> for the deer hunting community. The hunt begins soon.</div>
            </footer>
        </div>
    );
};

export default TrophyTask;
